import React from 'react';

import './AdminLogin.css';
import TextField from "../../../components/TextField/TextField";
import API from "../../../components/api";
import Storage from '../../../utils/storage';
import {withRouter} from "../../../layouts/MainLayout/MainLayout";


class AdminLoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loginValue: '',
            passwordValue: '',
        }

        this.login = this.login.bind(this);
    }

    login() {
        API.loginAdmin(this.state.loginValue, this.state.passwordValue)
            .then(data => {
                const jwtToken = data.token;
                this.props.cookies.set('token', jwtToken, {path: '/'});
                Storage.set('token', jwtToken);

                API.adminMe()
                    .then(data => {
                        this.props.navigate('/admin/panel/services/');
                    })
                    .catch((error) => {
                        let message = 'Попробуйте еще раз или обновите страницу'
                        try {
                            const errorJson = JSON.parse(error.stack)
                            message = errorJson.message
                        } catch (e) {
                        }

                        this.props.addSnackbar("Неверный логин или пароль", {
                            icon: "AttentionAlert",
                            additionalText: message,
                            divider: true,
                            closeable: true,
                        });
                    })
            })
            .catch((error) => {
                let message = 'Попробуйте еще раз или обновите страницу'
                try {
                    const errorJson = JSON.parse(error.stack)
                    message = errorJson.message
                } catch (e) {
                }

                this.props.addSnackbar("Неверный логин или пароль", {
                    icon: "AttentionAlert",
                    additionalText: message,
                    divider: true,
                    closeable: true,
                });
            })
    }

    componentDidMount() {

    }

    render() {
        return <div className='admin-login-page'>
            <div className='login-form'>
                <div className='title'>
                    Панель администратора ЭСТЭЙ
                </div>
                <TextField label='Логин' fullWidth value={this.state.loginValue}
                           onChange={(e) => this.setState({loginValue: e.target.value})}/>
                <TextField label='Пароль' fullWidth value={this.state.passwordValue} type='password'
                           onChange={(e) => this.setState({passwordValue: e.target.value})}/>
                <div className='button' onClick={this.login}>
                    Войти
                </div>
            </div>
        </div>
    }
}


export default withRouter(AdminLoginPage);
